function Footer() {
  return null;
}

export default Footer;
